

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { StatoPratica } from "src/app/models/statoPratica.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { ListeService } from "src/app/services/liste.service";
import { MagazzinoService } from "src/app/services/magazzino.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";

  

@Component({
    selector: "component-modifica_stato",
    templateUrl: "./dialog-modifica_stato.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaStato implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected cambiaStatoForm: FormGroup;
    protected isCambiandoStato:boolean = false;
    protected fase:number = 1;
    protected listaStatiFlowdy:StatoPratica[]=[];
  
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      public stiliService:StiliService,
      private utilService:UtilService,
      private magazzinoService:MagazzinoService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.fase             = this.config.data.fase;
      this.cambiaStatoForm = this.formBuilder.group({
        stato:          new FormControl({value: this.fase===1?this.pratica.statoFlowdyFase1:this.pratica.statoFlowdyFase2, disabled: true}, Validators.required),
      });
      
    }
  
    ngOnInit(): void {
      this.loadStatiFlowdy();
    }

    loadStatiFlowdy(){
      this.utilService.getStatiFlowdy().subscribe({
            next: (res) => {
                this.listaStatiFlowdy = res;
                this.cambiaStatoForm.get("stato").enable();
            },  error: (e) => {
              this.isCambiandoStato = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di aggiornamento dello stato della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
      });
    }

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isCambiandoStato = true;
        this.praticheService.modificaStatoPratica(this.pratica.id, this.cambiaStatoForm.value.stato.id, this.fase).subscribe( {
          
            next: (res) => {
              //chiama metodo del magazzino per annullare eventuali movimenti di magazzino
              this.magazzinoService.praticaConsegnaAnnulla(this.pratica.id).subscribe( {
                next: (res) => {
                  this.dialogRef.close({ success: true });
                },
                error: (e) => {
                  this.dialogRef.close({ success: false });
                }
              });
              //this.dialogRef.close({ success: true });
              
            },  error: (e) => {
              this.isCambiandoStato = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di aggiornamento dello stato della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
       
      } 
    }
  
  }